/* SmartPaw - winkelwagen upsell
   - voegt een upsell toe met een verborgen eigenschap _sp_for = product-id van
     de regel waaronder hij hoort
   - zet toegevoegde upsells in de DOM net onder hun "ouder"-regel
   Gedelegeerd op document, zodat alles blijft werken nadat de winkelwagen
   opnieuw is opgebouwd via ?section_id=helper-cart. */
(function () {
	if (window.__spCartUpsell) { return; }
	window.__spCartUpsell = true;

	var LINE = '[data-js-cart-item]';

	function isCard(node) {
		return node.nodeType === 1 && node.hasAttribute('data-cart-upsell');
	}
	function isLine(node) {
		return node.nodeType === 1 && node.hasAttribute('data-js-cart-item');
	}

	/* Groepeert de kinderen van de lijst in blokken: een upsell-kaart hoort bij
	   de regel die er direct onder staat. */
	function buildBlocks(container) {
		var blocks = [];
		var pending = [];
		Array.prototype.forEach.call(container.children, function (node) {
			if (isCard(node)) {
				if (pending.length) { blocks.push(pending); }
				pending = [node];
			} else if (isLine(node)) {
				pending.push(node);
				blocks.push(pending);
				pending = [];
			} else {
				if (pending.length) { blocks.push(pending); pending = []; }
				blocks.push([node]);
			}
		});
		if (pending.length) { blocks.push(pending); }
		return blocks;
	}

	function lineOf(block) {
		for (var i = 0; i < block.length; i++) {
			if (isLine(block[i])) { return block[i]; }
		}
		return null;
	}

	function reorder(container) {
		if (!container) { return; }

		var blocks = buildBlocks(container);
		var parents = [];
		var childMap = {};
		var moved = false;

		blocks.forEach(function (block) {
			var line = lineOf(block);
			var parentId = line && line.getAttribute('data-sp-for');
			if (parentId) {
				if (!childMap[parentId]) { childMap[parentId] = []; }
				childMap[parentId].push(block);
			} else {
				parents.push(block);
			}
		});

		var ordered = [];
		parents.forEach(function (block) {
			ordered.push(block);
			var line = lineOf(block);
			var id = line && line.getAttribute('data-product-id');
			if (id && childMap[id]) {
				childMap[id].forEach(function (child) { ordered.push(child); moved = true; });
				delete childMap[id];
			}
		});
		/* wees-regels: de ouder is uit de winkelwagen verwijderd */
		Object.keys(childMap).forEach(function (id) {
			childMap[id].forEach(function (child) { ordered.push(child); });
		});

		if (!moved) { return; }

		var fragment = document.createDocumentFragment();
		ordered.forEach(function (block) {
			block.forEach(function (node) { fragment.appendChild(node); });
		});
		container.appendChild(fragment);
	}

	function reorderAll() {
		var form = document.getElementById('AjaxCartForm');
		if (!form) { return; }
		['.cart__items', '.cart-form__items'].forEach(function (sel) {
			reorder(form.querySelector(sel));
		});
	}

	function refreshCartSection(done) {
		fetch('?section_id=helper-cart')
			.then(function (response) { return response.text(); })
			.then(function (text) {
				var parsed = new DOMParser().parseFromString(text, 'text/html');
				var form = document.getElementById('AjaxCartForm');
				var newForm = parsed.getElementById('AjaxCartForm');
				if (form && newForm) {
					form.innerHTML = newForm.innerHTML;
					if (typeof form.ajaxifyCartItems === 'function') { form.ajaxifyCartItems(); }

					var count = form.querySelector('[data-cart-count]');
					if (count) {
						document.querySelectorAll('[data-header-cart-count]').forEach(function (elm) {
							elm.textContent = count.textContent;
						});
					}
					var total = form.querySelector('[data-cart-total]');
					if (total) {
						document.querySelectorAll('[data-header-cart-total]').forEach(function (elm) {
							elm.textContent = total.textContent;
						});
					}
				}

				var subtotal = document.getElementById('AjaxCartSubtotal');
				var newSubtotal = parsed.getElementById('AjaxCartSubtotal');
				if (subtotal && newSubtotal) { subtotal.innerHTML = newSubtotal.innerHTML; }

				reorderAll();
				syncAllCarousels();

				if (form) { form.dispatchEvent(new Event('cart-updated')); }
				document.dispatchEvent(new CustomEvent('bogos:progress-rerender'));
			})
			.catch(function (e) { console.log('cart upsell refresh', e); })
			.finally(function () { if (typeof done === 'function') { done(); } });
	}


	/* ---------- carrousel ---------- */

	function cardWidth(track) {
		var card = track.querySelector('.cart-upsell-card');
		if (!card) { return track.clientWidth; }
		var style = window.getComputedStyle(track);
		var gap = parseFloat(style.columnGap || style.gap) || 0;
		return card.getBoundingClientRect().width + gap;
	}

	function pages(track) {
		var step = cardWidth(track);
		if (!step) { return 1; }
		return Math.max(1, Math.round(track.scrollWidth / (track.clientWidth || step)));
	}

	function syncCarousel(section) {
		var track = section.querySelector('[data-cart-upsells-track]');
		var nav = section.querySelector('[data-cart-upsells-nav]');
		var dots = section.querySelector('[data-cart-upsells-dots]');
		if (!track) { return; }

		var scrollable = track.scrollWidth - track.clientWidth > 4;
		if (nav) { nav.hidden = !scrollable; }
		if (dots) { dots.hidden = !scrollable; }
		if (!scrollable) { if (dots) { dots.innerHTML = ''; } return; }

		var total = pages(track);
		var current = Math.round(track.scrollLeft / (track.clientWidth || 1));

		var prev = section.querySelector('[data-cart-upsells-prev]');
		var next = section.querySelector('[data-cart-upsells-next]');
		if (prev) { prev.disabled = track.scrollLeft <= 2; }
		if (next) { next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }

		if (dots) {
			if (dots.children.length !== total) {
				dots.innerHTML = '';
				for (var i = 0; i < total; i++) {
					var dot = document.createElement('button');
					dot.type = 'button';
					dot.className = 'cart-upsells__dot';
					dot.setAttribute('data-cart-upsells-dot', String(i));
					dot.setAttribute('aria-label', String(i + 1));
					dots.appendChild(dot);
				}
			}
			Array.prototype.forEach.call(dots.children, function (dot, i) {
				dot.classList.toggle('is-active', i === current);
			});
		}
	}

	function syncAllCarousels() {
		document.querySelectorAll('[data-cart-upsells]').forEach(function (section) {
			var track = section.querySelector('[data-cart-upsells-track]');
			if (track && !track.__spBound) {
				track.__spBound = true;
				track.addEventListener('scroll', function () { syncCarousel(section); }, { passive: true });
			}
			syncCarousel(section);
		});
	}

	document.addEventListener('click', function (event) {
		var arrow = event.target.closest('[data-cart-upsells-prev], [data-cart-upsells-next]');
		var dot = event.target.closest('[data-cart-upsells-dot]');
		if (!arrow && !dot) { return; }

		var section = (arrow || dot).closest('[data-cart-upsells]');
		var track = section && section.querySelector('[data-cart-upsells-track]');
		if (!track) { return; }
		event.preventDefault();

		if (dot) {
			track.scrollLeft = parseInt(dot.getAttribute('data-cart-upsells-dot'), 10) * track.clientWidth;
		} else {
			var step = track.clientWidth || cardWidth(track);
			track.scrollLeft += arrow.hasAttribute('data-cart-upsells-next') ? step : -step;
		}
	});

	window.addEventListener('resize', syncAllCarousels);

	document.addEventListener('click', function (event) {
		var button = event.target.closest('[data-cart-upsell-add]');
		if (!button) { return; }

		event.preventDefault();

		var id = parseInt(button.getAttribute('data-variant-id'), 10);
		if (!id || button.disabled) { return; }

		var card = button.closest('[data-cart-upsells]');
		var label = button.querySelector('[data-cart-upsell-label]');
		var added = button.getAttribute('data-label-added');
		var parentId = button.getAttribute('data-parent-id');

		var line = { id: id, quantity: 1 };
		if (parentId) { line.properties = { _sp_for: parentId }; }

		/* de kaart is zelf het cadeau van zijn ouderregel: toevoegen als
		   cadeauregel, de automatische korting zet hem op nul */
		var freeCard = button.closest('[data-free-for]');
		if (freeCard) { line.properties = { _sp_gift: freeCard.getAttribute('data-free-for') }; }

		var lines = [line];

		/* de gemarkeerde kaart brengt zijn cadeau mee; een automatische korting
		   in Shopify zet dat product op nul */
		var giftCard = button.closest('[data-gift-variant]');
		var giftId = giftCard ? parseInt(giftCard.getAttribute('data-gift-variant'), 10) : 0;
		if (giftId) {
			lines.push({ id: giftId, quantity: 1, properties: { _sp_gift: String(id) } });
		}

		button.disabled = true;
		if (card) { card.classList.add('is-loading'); }

		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ items: lines })
		})
			.then(function (response) { return response.json(); })
			.then(function () {
				if (label && added) { label.textContent = added; }
				refreshCartSection();
			})
			.catch(function (e) {
				console.log('cart upsell add', e);
				button.disabled = false;
				if (card) { card.classList.remove('is-loading'); }
			});
	});

	/* ook bij een gewone paginalading en na verversingen door het thema zelf */
	function removeThemeCartExtras() {
		/* het thema zet bestellinginstructies en een dichtgeklapte kortingscode
		   in de drawer; die staan nu onderaan in cart-subtotal, dus dit blok weg */
		document.querySelectorAll('.sidebar__body-bottom').forEach(function (block) {
			block.remove();
		});
	}

	/* ---------- weesgeschenken opruimen ----------
	   Een cadeauregel staat verborgen in beeld: hij wordt getoond als strookje
	   onder het product waarvoor hij gegeven is. Haalt de klant dat product weg,
	   dan blijft het cadeau achter — onzichtbaar én plots betalend, want de
	   automatische korting vervalt. Daarom halen we zo'n weesregel meteen weg. */
	var pruning = false;

	function pruneOrphanGifts(done) {
		if (pruning) { if (typeof done === 'function') { done(); } return; }

		var gifts = document.querySelectorAll('[data-sp-gift]');
		if (!gifts.length) { if (typeof done === 'function') { done(); } return; }

		fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				var present = {};
				cart.items.forEach(function (item) { present[String(item.variant_id)] = true; });

				var orphans = cart.items.filter(function (item) {
					var parent = item.properties && item.properties._sp_gift;
					return parent && !present[String(parent)];
				});
				if (!orphans.length) { return null; }

				pruning = true;
				var updates = {};
				orphans.forEach(function (item) { updates[item.key] = 0; });
				return fetch('/cart/update.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body: JSON.stringify({ updates: updates })
				}).then(function () { pruning = false; refreshCartSection(done); return true; });
			})
			.then(function (didPrune) { if (!didPrune && typeof done === 'function') { done(); } })
			.catch(function (e) { pruning = false; console.log('cart upsell prune', e); if (typeof done === 'function') { done(); } });
	}

	function init() { removeThemeCartExtras(); reorderAll(); syncAllCarousels(); pruneOrphanGifts(); }
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	document.addEventListener('cart-updated', init, true);
})();
